import { InputHTMLAttributes } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { TotemSwitch } from '../TotemSwitch';

type DetailFormCheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'defaultValue'> & {
    label?: string;
    sublabel?: string;
    name: string;
    defaultChecked?: boolean;
    disabled?: boolean;
    dataTest?: string;
};

export const DetailFormCheckbox = ({
    label,
    sublabel,
    name,
    defaultChecked = false,
    disabled = false,
    dataTest,
}: DetailFormCheckboxProps) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultChecked}
            render={({ field: { onChange, value } }) => (
                <TotemSwitch
                    label={label}
                    sublabel={sublabel}
                    checked={value}
                    onChange={onChange}
                    disabled={disabled}
                    dataTest={dataTest}
                />
            )}
        />
    );
};
